import { Button, Container, Grid, Stack, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { useCallback, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';

import Page from '../../components/Page';
import PageTitle from '../../components/PageHeading';
import BrudCrumbs from '../../components/BreadCrumbs';
import CustomInput from '../../components/CustomInput';
import CustomSelect from '../../components/CustomSelect';

import { saveApiData } from '../../store/Slice/Global/GlobalSlice';
import { UserApi } from '../../utils/Apis';
import useLoginSelector from '../../store/Slice/Login/LoginSelector';
import useGlobalSelector from '../../store/Slice/Global/GlobalSelector';
import { setApiError } from '../../store/Slice/Error/ErrorSlice';

function EditIncentive() {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { LoginData } = useLoginSelector();
  const { BankDrop, LoanTypeDrop } = useGlobalSelector();

  const incentiveData = location.state; // old incentive object

  // console.log('incentiveData2222', incentiveData);

  const {
    handleSubmit,
    control,
    reset,
    watch,
    formState: { errors }
  } = useForm({
    mode: 'onBlur',
    defaultValues: {
      incentiveType: '',
      minAmount: '',
      maxAmount: '',
      incentivePercent: '',
      companyPercentage: '',
      duration: '',
      bankId: '',
      loanType: ''
    }
  });

  /* ---------------- PREFILL DATA ---------------- */
  /* ---------------- PREFILL DATA ---------------- */
  useEffect(() => {
    if (!incentiveData || !BankDrop || !LoanTypeDrop) return;

    // console.log('Prefilling form with incentiveData:', incentiveData);
    // console.log('Available LoanTypeDrop:', LoanTypeDrop);

    // Find matching bank from BankDrop (search by label if bankName is provided)
    const selectedBank =
      BankDrop?.find(
        (bank) => bank.value === incentiveData.bankId || bank.label === incentiveData.bankName
      ) || null;

    // console.log('selectedBank found:', selectedBank);

    // Find matching loan type from LoanTypeDrop (search by LABEL since loanType comes as label)
    const selectedLoanType =
      LoanTypeDrop?.find((loan) => loan.label === incentiveData.loanType) || null;

    // console.log('selectedLoanType found:', selectedLoanType);
    // console.log('loanType from incentiveData:', incentiveData.loanType);

    // Check if we found matches, if not, try exact match
    const finalLoanType =
      selectedLoanType ||
      (incentiveData.loanType
        ? { label: incentiveData.loanType, value: incentiveData.loanType }
        : null);

    const finalBank =
      selectedBank ||
      (incentiveData.bankName
        ? { label: incentiveData.bankName, value: incentiveData.bankId || incentiveData.bankName }
        : null);

    // console.log('finalLoanType:', finalLoanType);
    // console.log('finalBank:', finalBank);

    reset({
      incentiveType: incentiveData.incentiveType || '',
      minAmount: incentiveData.minAmount || '',
      maxAmount: incentiveData.maxAmount || '',
      incentivePercent: incentiveData.incentivePercent || '',
      companyPercentage: incentiveData.companyPercentage || '',
      duration: incentiveData.duration || '',
      bankId: finalBank || '',
      loanType: finalLoanType || ''
    });
  }, [incentiveData, reset, BankDrop, LoanTypeDrop]);
  /* ---------------- SUBMIT ---------------- */
  const onSubmit = useCallback(
    async (data) => {
      let payload = {
        id: incentiveData?.id,
        incentiveType: incentiveData?.incentiveType,
        incentivePercent: Number(data.incentivePercent),
        duration: data.duration,
        companyPercentage: Number(data.companyPercentage),
        userId: LoginData?.userId
      };

      // ✅ TARGET BASED
      if (incentiveData?.incentiveType === 'TARGET_BASED') {
        payload = {
          ...payload,
          minAmount: Number(data.minAmount),
          maxAmount: Number(data.maxAmount)
        };
      }

      // ✅ DISBURSEMENT BASED
      if (incentiveData?.incentiveType === 'DISBURSEMENT_BASED') {
        payload = {
          ...payload,
          bankId: data.bankId?.value ?? data.bankId,
          loanTypeId: data.loanType?.value ?? data.loanType
        };
      }

      const res = await dispatch(saveApiData(UserApi.editIncentive, payload));

      if (res?.status === 'success') {
        dispatch(setApiError('Updated successfully'));
        navigate('users/set-incentive-for-employeePartner');
      }
    },
    [dispatch, incentiveData, LoginData, navigate]
  );

  const newBankDrop = [{ label: 'All', value: 0 }, ...BankDrop] || [];
  const newMasterLoanTypeDrop = [{ label: 'All', value: 0 }, ...LoanTypeDrop] || [];
  return (
    <Page title="Kpros || Edit Incentive">
      <Container maxWidth="xl">
        <Box pt={3} pb={3} mb={4}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            className="pageHeading"
          >
            <PageTitle info="Edit Incentive" />
            <Box>
              <BrudCrumbs />
            </Box>
          </Stack>

          <Typography variant="body1" className="headingLineUp headingLineUpOut">
            Incentive Details
          </Typography>

          <Box className="viewLeadCard cardTopMinusMargin" mb={3}>
            <form id="EditIncentiveForm" onSubmit={handleSubmit(onSubmit)}>
              <Grid container spacing={3}>
                {incentiveData?.incentiveType === 'TARGET_BASED' && (
                  <>
                    <Grid item xs={4}>
                      <CustomInput
                        name="minAmount"
                        label="Minimum Amount"
                        control={control}
                        errors={errors}
                        isRequired
                        fieldType="NUMBER"
                      />
                    </Grid>

                    <Grid item xs={4}>
                      <CustomInput
                        name="maxAmount"
                        label="Maximum Amount"
                        control={control}
                        errors={errors}
                        isRequired
                        fieldType="NUMBER"
                      />
                    </Grid>
                  </>
                )}

                {incentiveData?.incentiveType === 'DISBURSEMENT_BASED' && (
                  <>
                    <Grid item xs={4}>
                      <CustomSelect
                        name="bankId"
                        label="Bank"
                        control={control}
                        options={newBankDrop}
                        errors={errors}
                        isRequired
                      />
                    </Grid>

                    <Grid item xs={4}>
                      <CustomSelect
                        name="loanType"
                        label="Loan Type"
                        control={control}
                        options={newMasterLoanTypeDrop}
                        errors={errors}
                        isRequired
                      />
                    </Grid>
                  </>
                )}

                <Grid item xs={4}>
                  <CustomInput
                    name="incentivePercent"
                    label="Incentive Percentage"
                    control={control}
                    errors={errors}
                    isRequired
                    fieldType="DECIMAL"
                  />
                </Grid>

                <Grid item xs={4}>
                  <CustomInput
                    name="companyPercentage"
                    label="Company Percentage"
                    control={control}
                    errors={errors}
                    isRequired
                    fieldType="DECIMAL"
                  />
                </Grid>

                <Grid item xs={4}>
                  <CustomSelect
                    name="duration"
                    label="Duration"
                    control={control}
                    errors={errors}
                    isRequired
                    options={[
                      { label: 'Monthly', value: 'MONTHLY' },
                      { label: 'Quarterly', value: 'QUARTERLY' },
                      { label: 'Yearly', value: 'YEARLY' }
                    ]}
                  />
                </Grid>
              </Grid>
            </form>
          </Box>

          <Box textAlign="right">
            <Button variant="contained" className="mainBtn" type="submit" form="EditIncentiveForm">
              Update Incentive
            </Button>
          </Box>
        </Box>
      </Container>
    </Page>
  );
}

export default EditIncentive;
